import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Text } from '@fragments';
import useTyping from './hooks/useTyping';

// The outgoing label slides up out of the one-line window (slot reel); the next
// one types itself in place once the reel has mostly cleared.
const SLOT_EXIT_S = 0.32;
const TYPE_AFTER_SLOT_MS = 220;
const slotExit = { y: '-110%', opacity: 0, transition: { duration: SLOT_EXIT_S, ease: [0.4, 0, 0.2, 1] } };

function TypedLabel({ text, loading, delayMs }) {
  // Fixed at mount, so later re-renders (run polling) never restart the typing.
  const [startDelay] = useState(delayMs);
  const { typed, typing } = useTyping(text, { delayMs: startDelay });
  return <>
    <span className="studio-visually-hidden">{text}</span>
    <Text.label aria-hidden="true" contrast={8} loading={loading}>{typed || '​'}</Text.label>
    {typing && <span className="studio-run__caret" aria-hidden="true" />}
  </>;
}

export default function StepTicker({ id, text, loading }) {
  // The first label types right away; later ones wait for the previous to roll out.
  const mounted = useRef(false);
  useEffect(() => { mounted.current = true; }, []);
  return <span className="studio-run__slot">
    <AnimatePresence initial={false}>
      <motion.span key={id} className="studio-run__slot-item" exit={slotExit}>
        <TypedLabel text={text} loading={loading} delayMs={mounted.current ? TYPE_AFTER_SLOT_MS : 0} />
      </motion.span>
    </AnimatePresence>
  </span>;
}
